import React, {useCallback, useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {Link} from "react-router-dom"
import {useParams} from 'react-router'

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import axios from "axios"
import {toast} from "react-toastify"

import {TextField, Button, Box} from "@material-ui/core"

import Typography from '@mui/material/Typography'

import inputLimits from '../../constants/inputLimits'
import {urlApi} from "../../api"
import {loadingToggle} from "../../store/actions/appActions"
import {useStyles} from '../../themes/styles'
import { startTransition } from 'react'
import {readDateTime, sortTimes} from '../../fns/times'
import FormControlLabel from '@mui/material/FormControlLabel'
import {ThemeProvider} from '@mui/material/styles'
import theme from '../../themes/_main'

import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
const stripePromise = loadStripe("pk_test_51RDyTyDUWAYG8wIto0ad0qMnrifPuI75HO8wBqBYG3YPerYwx40CAwW5dg4NthoPBUvSDNciWdTDHs19jOb9Ktq9003cSQxLIc");

const minNoticeString = "24 hours"
const minNoticeMs = 1000 * 60 *60 * 24  // 24 hours

const Confirmation = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const {idxPurchase} = useParams()
  const prices = useSelector(state => state.app.dataServer.prices)

  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [timeConfirmed, setTimeConfirmed] = useState(null)
  const [date, setDate] = React.useState("")
  const [time, setTime] = React.useState(0)
  const [times, setTimes] = React.useState({})
  const [total, setTotal] = React.useState(0)
  const [dates, setDates] = React.useState([])
  const [showCheckout, setShowCheckout] = React.useState(false)
  const [showAdd, setShowAdd] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = React.useState(true)
  const [rescheduled, setRescheduled] = React.useState(true)
  const [purchased, setPurchased] = React.useState({})
  const [showAddons, setShowAddons] = React.useState(false)
  const [displayButtonAddons, setDisplayButtonAddons] = React.useState(false)
  const [displayButtonPurchase, setDisplayButtonPurchase] = React.useState(false)


  let priceObj = {}
  for (let i = 0; i < prices.length; ++i) {
    // console.log(priceKeys[i])
    priceObj[prices[i].item] = false
  }

  const [pricesObjChecked, setPricesObjChecked] = React.useState(priceObj)

  useEffect(() => {
    window.scrollTo(0,0)
    dispatch(loadingToggle(true))

    props.socket.on(`confirm`, () => {
      dispatch(loadingToggle(false))
      console.log("ALLL READY")
    })

    props.socket.on('purchaseComplete', (purchase, times) => {
      console.log("PURCHASE COMPLETE")
      resetTimes(purchase.timeAppointment, times)
      console.log("PURCHASECOMPLETE")
      console.log("purchase", purchase)
      updatePurchase(purchase)
    })

    window.grecaptcha.ready(function() {
      window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', {action: 'submit'}).then(function(recaptchaToken) {
        axios
        .post(`${urlApi}/oss/getPurchase`, {recaptchaToken, idxPurchase, idSocket: props.socket.id}, {"withCredentials": true})
        .then(resp => {
          if (resp.data) {
            console.log(resp.data)
            // setTimeConfirmed(resp.data.purchase.timeAppointment)
            // setTimes(resp.data.times)
            resetTimes(resp.data.purchase.timeAppointment, resp.data.times)
            updatePurchase(resp.data.purchase)
            // const sortedTimes = sortTimes(resp.data.times)
            // setTimes(sortedTimes)
            // const sortedDates = Object.keys(sortedTimes)
            // setDates(sortedDates)
            // dispatch(loadingToggle(false))
          }
        })
        .catch(error => {
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
          })
          dispatch({
            type: "LOADING_TOGGLE",
            isLoading: false,
          })
        })
      })
    })
  },[])


  const fontSizes = {
    h1: "24px",
    h2: 22,
    h3: 20,
    b1: 18,
    b2: 16,
  }

  const fetchClientSecret = useCallback(async() => {
    const recaptchaToken = await new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', { action: 'submit' })
        .then(resolve)
        .catch(reject);
      });
    });
    
    const checkout = {
      pricesObjChecked,
    }
    const body = {
      recaptchaToken,
      checkout,
      idxPurchase,
    }
    // // Create a Checkout Session
    // return fetch(`${urlApi}/oss/stripe-create-checkout-session`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify(body),
    // })
    //   .then((res) => res.json())
    //   .then((data) => {
    //     if (!data.clientSecret) {
    //       throw new Error(data.error);
    //     }
    //     return data.clientSecret
    //   })
    //   .catch((err) => {
    //     console.error("Checkout session creation failed:", err.message)
    //     setShowCheckout(false)
    //     return ""
    //   })
    const res = await fetch(`${urlApi}/oss/stripe-create-checkout-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text(); // fallback if not valid JSON
      throw new Error(errorText || "Failed to create checkout session");
    }

    const data = await res.json();

    if (!data.clientSecret) {
      throw new Error(data.error || "Missing clientSecret in response");
    }

    return data.clientSecret;
  }, [
    pricesObjChecked,
  ]);
  const options = {fetchClientSecret};


  const getChecked = (step) => {
    // return false
    if (step.item == "Base Package") return true
    return pricesObjChecked[step.item]
    return false
    console.log(step)
    console.log(pricesObjChecked)
    console.log(pricesObjChecked[step.item])
    return pricesObjChecked[step.item]
    // console.log(pricesChecked[index])
    // return (index == 0 || pricesChecked[index])
  }

  const handleAddons = () => {
    console.log(prices)
    setShowAddons(true)
  }

  const handleBack = () => {
    if (showCheckout) {
      setShowCheckout(false)
    }
    else {
      setShowAddons(false)
    }
  }


  const handleChangeDate = (event) => {
    setDate(event.target.value)
    setTime(0)
    setDisableSubmit(true)
  }
  const handleChangeTime = (event) => {
    console.log(event.target.value)
    // console.log(times[date][event.target.value])
    // setTime(times[date][event.target.value])
    setTime(event.target.value)
    setDisableSubmit(false)
  }

  const handleCheck = (step) => {
    console.log(step)
    console.log(pricesObjChecked)
    let obj = pricesObjChecked
    obj[step.item] = !obj[step.item]
    setPricesObjChecked({...obj})
    setTotal(total + ((obj[step.item] ? 1 : -1) * step.price))
    // setPricesObjChecked({...pricesObjChecked, qwe: false})
    let allowSubmit = false
    for (let i = 1; i < prices.length; ++i) {
      const itemName = prices[i].item
      const checked = pricesObjChecked[itemName]
      if (checked) {
        allowSubmit = true
        break
      }
    }
    setDisplayButtonPurchase(allowSubmit)
  }

  const handleReschedule = () => {
    const timezoneOffset = new Date().getTimezoneOffset()
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', {action: 'submit'}).then(function(recaptchaToken) {
        axios
        .post(`${urlApi}/oss/reschedule`, {recaptchaToken, idxPurchase, time, timezoneOffset}, {"withCredentials": true})
        .then(resp => {
          console.log("RESPDATA")
          console.log(resp.data)
          // setTimeConfirmed(resp.data.timeRequest)
          resetTimes(resp.data.timeRequest, resp.data.times)
          setRescheduled(true)
        })
        .catch(error => {
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
          })
          dispatch({
            type: "LOADING_TOGGLE",
            isLoading: false,
          })
        })
      })
    })
    
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    console.log("submit")
    setShowCheckout(true)
  }

  const resetTimes = (timeAppointment, timesAvailable) => {
    setTimeConfirmed(timeAppointment)
    console.log(timesAvailable)
    console.log("LENGTH")
    console.log(timesAvailable.length)
    if (timesAvailable.length) {
      console.log("IFFFF")
      const sortedTimes = sortTimes(timesAvailable)
      setTimes(sortedTimes)
      const sortedDates = Object.keys(sortedTimes)
      setDates(sortedDates)
      setDate(0)
      setTime(0)
    }
    dispatch(loadingToggle(false))
  }

  const sxList = {
    fontSize: fontSizes.h1,
    paddingTop: "7px",
  }
  const sxListBold = {
    ...sxList,
    fontWeight: 'bold',
  }

  const updatePurchase = (purchase) => {
    let showAddonsButton = false
    for (let i = 1; i < prices.length; ++i) {
      const itemName = prices[i].item
      if (purchase.itemsPurchased[itemName] == false) {
        showAddonsButton = true
        break
      }
    }
    setDisplayButtonAddons(showAddonsButton)
    setPurchased(purchase)
    setShowAddons(false)
    setShowCheckout(false)
  }

  if (timeConfirmed == null) {
    console.log("timeConfirmed == NULL")
    return <></>
  }

  if (timeConfirmed && timeConfirmed < new Date()) {
    return <>
      <Typography variant="h5" className={/*getChecked(index) ? classes.textGrey : */""}>
        Your appointment has passed. It was scheduled for:
      </Typography>
      <Typography variant="h4" className={classes.spacing}>
        {readDateTime(timeConfirmed)}
      </Typography>
    </>
  }

  const componentButtonBack = (
    <div className={classes.spacing}>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        onClick={handleBack}
      >
        Back
      </Button>
    </div>
  )

  const componentAddons = (<>
    {componentButtonBack}
    <form
    className={classes.formStyle}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}>
      {console.log("prices", prices)}
      {console.log(purchased, purchased.itemsPurchased)}
      <div id="prices">
        {prices.map((step, index) => (<>
          {(Boolean(index) && purchased && purchased.itemsPurchased && !purchased.itemsPurchased[prices[index].item]) && <>
          {/* {console.log(step)} */}
            <Box
            key={index}
            component="span"
            className={classes.spreadBoxFull + " " + classes.spacing}
            >
              <FormControlLabel onChange={() => handleCheck(step)} control={<Checkbox checked={pricesObjChecked[step.item]}/>} disabled={index==0} label={step.item} sx={{ '& .MuiFormControlLabel-label': {...sxList, "&.Mui-disabled":{color: "black"} } }}/>
              <Typography className={/*getChecked(index) ? classes.textGrey : */""} sx={{...sxListBold, color: (getChecked(step) ? "black" : "grey")}}>
                ${step.price}
              </Typography>
              
            </Box>
          </>}
        </>))}
        <Box
        component="span"
        className={classes.spreadBoxFull + " " + classes.spacing}
        >
          <div></div>
          <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={sxListBold}>
              -----
            </Typography>
        </Box>
        <Box
        component="span"
        className={classes.spreadBoxFull + " " + classes.spacing}
        >
          <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={{fontSize: fontSizes.h1, fontWeight: 'bold', "paddingTop": "7px"}}>
              Total
            </Typography>
          <Typography variant="body1" className={/*getChecked(index) ? classes.textGrey : */""} sx={{fontSize: fontSizes.h1, fontWeight: 'bold', "paddingTop": "7px"}}>
              ${total}
            </Typography>
        </Box>
      </div>

      
      <div className={classes.spacing}>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!displayButtonPurchase}
        >
          Submit
        </Button>
      </div>
      

    </form></>
  )

  const componentCheckout = (<>
    <div className={classes.spacing}>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        onClick={handleBack}
      >
        Back
      </Button>
    </div>
    <div id="checkout" className={classes.spacing}>
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
    </>)

  const componentPurchased = (<>
    <div id="purchased">
      <Typography variant="h5" className={classes.spacing}>
        Your package currently includes:
      </Typography>
      <ul>
        {prices.map((step, index) => (<>
          {purchased && (index == 0 || (purchased.itemsPurchased && purchased.itemsPurchased[prices[index].item])) && <>
          {/* {console.log(step)} */}
            <Box
            key={index}
            component="span"
            className={classes.spreadBoxFull + " " + classes.spacing}
            >
              <Typography variant="h5">
                <li>{step.item}</li>
              </Typography>
            </Box>
          </>}
        </>))}
      </ul>
      {displayButtonAddons &&
        <div className={classes.spacing}>
          <Button
            className={classes.spacing}
            variant="contained"
            color="primary"
            type="submit"
            onClick={handleAddons}
          >
            Purchase Add-Ons
          </Button>
        </div>
      }
    </div>

      
    </>

  )

  return (

    <ThemeProvider theme={theme}>
      {showAddons ? 
        <>
          {showCheckout ?
            componentCheckout
          :
            componentAddons
          }
        </>
      :
        <>
          {componentPurchased}
          <div className={classes.shadowDivider}/>
          {timeConfirmed ? <>
            <Typography variant="h5" className={classes.spacing}>
            Your appointment is confirmed for:
            </Typography>
            <Typography variant="h4" className={classes.spacing}>
              {readDateTime(timeConfirmed)}
            </Typography>
            <Typography variant="h5" className={classes.spacing}>
              If you cannot make your appointment, you may reschedule at least {minNoticeString} in advance.
            </Typography>
          </> : <>
            <Typography variant="h5" className={/*getChecked(index) ? classes.textGrey : */""}>
              You do not have an appointment scheduled. Please schedule one at your earliest convenience.
            </Typography>
          </>}
          {(!timeConfirmed || (timeConfirmed - new Date().getTime() > minNoticeMs)) ?
            <Box
            className={classes.spacing}
            >
              Video Call Appointment
              <FormControl fullWidth>
                <InputLabel id="dates" className={classes.spacing}>Date</InputLabel>
                <Select
                  labelId="datesLabel"
                  id="datesSelect"
                  className={classes.spacing}
                  value={date}
                  label="Date"
                  onChange={handleChangeDate}
                >
                  {dates.map((step, index) => (
                    <MenuItem key={index} value={step}>{step}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              {date ?
                <FormControl fullWidth>
                  <InputLabel id="times" className={classes.spacing}>Time</InputLabel>
                  <Select
                    labelId="timesLabel"
                    id="timesSelect"
                    className={classes.spacing}
                    value={time}
                    label="Time"
                    onChange={handleChangeTime}
                  >
                    {times[date].map((step, index) => (
                      <MenuItem key={index} value={step.dateTime}>{step.timeString}</MenuItem>
                    ))}
                    </Select>
                </FormControl>
              :
                <></>
              }
              <div className={classes.spacing}>
                <Button
                  className={classes.spacing}
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={!time}
                  onClick={handleReschedule}
                >
                  {timeConfirmed ? "Reschedule" : "Schedule"}
                </Button>
              </div>
            </Box>
          : <></>}
          </>
        }
  </ThemeProvider>)
}

export default Confirmation